module.exports = __webpack_public_path__ + "static/media/SF-17-A (1).50637c94.mp3";